import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Parts, Types} from "components";
import {Button, ButtonGroup} from 'reactstrap';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import classNames from "classnames";
import moment from "moment";
import API from "@beardeddevops/react.api";

const breadcrumbsStatic = [{
	name: 'Dispatch',
	url: '/dispatch',
	icon: 'dashboard',
}];

export default class TFOReschedules extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state = {
			filterInRegion: false,
			filterMostRecent: true,
			regions: [],
			filterRegion: null,
			tab: 'TFOs'
		};
		this.getRegions();
	}

	updateRegion = (region, name) => {
		this.setState({region, name})
	}

	getRegions = async () => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		if (this.props.popularRegions) {
			model.filter = {
				'filterPopular': true
			}
		}
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			this.regions = this.regions.filter(region => region.latitude > 0 || region.latitude < 0)
			this.setState({
				regions: this.regions
			});
		} catch (error) {
		}
		return this.state.regions;
	}


	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "TFOs/Reschedules",
				url: `/dispatch/tfos`,
				icon: 'laptop',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>
				<div className={'row'}>
					<div className={'col-4'}>
						<Parts.RegionSelectToggle
							parent={this}
							handleRegionsCallback={async () => {
								let selectedRegion = this.state.regions.filter(region => {
									return region.pkey === (this.state.filterRegion)
								})[0];
								await this.setState({
									filterInRegion: true,
									key: Math.random(),
									selectedRegion: {value: selectedRegion.pkey, label: selectedRegion.name}
								});
							}}
							multi={false}
							noCycle={false}
						/>
					</div>
					<div className={'col-auto'}>
						<ButtonGroup size={"md"}>
							<Button
								onClick={() => {
									this.setState({filterInRegion: true})
								}}
								outline={this.state.filterInRegion === false}
								active={this.state.filterInRegion === true}
							>
								In Region
							</Button>
							<Button
								onClick={() => {
									this.setState({filterInRegion: false})
								}}
								outline={this.state.filterInRegion === true}
								active={this.state.filterInRegion === false}
							>
								All Regions
							</Button>
						</ButtonGroup>
					</div>
					<div className={'col-auto'}>
						<ButtonGroup size={"md"}>
							<Button
								onClick={() => {
									this.setState({filterMostRecent: true})
								}}
								outline={this.state.filterMostRecent === false}
								active={this.state.filterMostRecent === true}
							>
								Recent First
							</Button>
							<Button
								onClick={() => {
									this.setState({filterMostRecent: false})
								}}
								outline={this.state.filterMostRecent === true}
								active={this.state.filterMostRecent === false}
							>
								Oldest First
							</Button>
						</ButtonGroup>
					</div>

				</div>
				<div className={'row'}>
					<div className={'col-12'}>
						<h4 style={{textAlign: 'center'}}>Please update notes if you call a customer!</h4>
					</div>
				</div>
				<Tabs
					value={this.state.tab}
					onChange={this.handleTabChange}
					component={'div'}>
					<Tab label="TFOs" value="TFOs"/>
					<Tab label="Reschedules" value="Reschedules"/>
					<Tab label="Prefers Sooner" value="Sooner"/>
				</Tabs>
				<div className={classNames({'hidden': this.state.tab !== 'TFOs'})}>
					<Collections.PhoneLogs
						key={this.state.filterInRegion + this.state.filterMostRecent + this.state.key}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={false}
						filter={{
							'filterTFO': true,
							'filterByRecent': this.state.filterMostRecent,
							'filterRegion': this.state.filterInRegion ? this.state.filterRegion : 'remote',
						}}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'Reschedules'})}>
					<Collections.Reschedules
						key={this.state.filterInRegion + this.state.filterMostRecent + this.state.key}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={false}
						filter={{
							'filterByRecent': this.state.filterMostRecent,
							'filterRegion': this.state.filterInRegion ? this.state.filterRegion : 'remote',
						}}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'Sooner'})}>
					<Collections.PrefersSooner
						key={this.state.filterInRegion + this.state.filterMostRecent + this.state.key}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCSV={false}
						filter={{
							'filterByRecent': this.state.filterMostRecent,
							'filterRegion': this.state.filterInRegion ? this.state.filterRegion : 'remote',
						}}
					/>
				</div>
			</div>
		);
	}
}

